<template>
  <!-- start 输入面板 -->
  <div>
    <div v-for="(items, key) in value" :key="key">
      <div
        class="input-panel"
        v-if="verifyNumberPagingPages(page, pageSize, key, value)"
      >
        <div class="show-input-panel">
          <span
            v-for="(item, key) in items"
            :key="key"
            :class="
              item.inputVal != item.key && item.inputVal != null
                ? 'mistake'
                : ''
            "
            :style="item.key == ' ' ? 'width:7.3px;' : ''"
          >
            <template>{{ item.key }}</template>
          </span>
        </div>
        <div class="input-panel-input">
          <input
            :ref="inputRefName(key)"
            contenteditable="true"
            v-model="inputVals[key]"
            :maxlength="value[key].length"
            :disabled="verifyEdit(isEdit, key, value)"
            @keyup="keyboardChangeSeats($event,key)"
            autofocus="autofocus"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- end 输入面板 -->
</template>

<script>
export default {
  name: "EnglishArticleInputPanel",
  data() {
    return {
      inputVals: [],
      val: "",
      // 分页数
      page: 1,
      // 分页大小
      pageSize: 5,
      refKey: 0,
      temp: 0,
    };
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    obtainCursor: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    obtainCursor: {
      handler(newVal) {
        if (newVal == true) {
          let that = this;
          this.$nextTick(() => {
            that.$refs["input-" + that.refKey][0].focus();
          });
        }
      },
    },
    inputVals: {
      handler(newVal) {
        this.value.forEach((item, key) => {
          if (newVal[key] != undefined) {
            let arr = newVal[key].split("");
            this.value[key].forEach((item, keys) => {
              this.value[key][keys].inputVal = arr[keys];
            });
          }
        });
        let sign = this.automaticPaging(this.page, this.pageSize, this.value);
        if (sign) {
          // this.page++;
          // this.temp = (this.page - 1) * this.pageSize;
          // let that = this;
          // this.$nextTick(() => {
          //   that.$refs["input-" + that.temp][0].focus();
          // });
        }
      },
    },
  },
  methods: {
    // 按键字符
    keyboardChangeSeats(event, key) {
      this.refKey = key;
      if (this.automaticPaging(this.page, this.pageSize, this.value,) && event.key == 'Enter') {
          this.page++;
          this.refKey = 1 + (this.page - 1) * this.pageSize -1;
          this.temp = this.refKey;
          let that = this;
          this.$nextTick(() => {
            that.$refs["input-" + that.refKey][0].focus();
          });
      }
    },
    // 光标位置
    handleInputBlur(key) {
      if(this.temp != 0){
        this.refKey = this.temp;
        return;
      }
      this.temp = 0; //编辑 关联函数游延迟性
      this.refKey = key;
      //console.log(key)
    },
    // input ref 名字
    inputRefName(key) {
      return "input-" + key;
    },
    // 验证分页页数
    verifyNumberPagingPages(page, pageSize, key, dataArr) {
      let startNum = pageSize * (page - 1) + 1;
      let endNum = startNum + (pageSize - 1);
      let total = Math.ceil(dataArr.length / pageSize);
      if (total < page) {
        return false;
      }
      if (startNum <= key + 1 && endNum >= key + 1) {
        return true;
      }
      return false;
    },
    // 验证编辑
    verifyEdit(isEdit, key, dataArr) {
      if (!isEdit) {
        return true;
      }
      if (key == 0) {
        return false;
      }
      let inputValNumber = 0;
      let strNumber = 0;
      dataArr.forEach((item, keys) => {
        item.forEach((items) => {
          if (items.inputVal != undefined) {
            inputValNumber++;
          }
        });
        if (key - 1 >= keys) {
          strNumber += item.length;
        }
      });
      if (inputValNumber >= strNumber) {
        return false;
      }
      return true;
    },
    // 翻页
    automaticPaging(page, pageSize, dataArr) {
      let startNum = pageSize * (page - 1) + 1;
      let endNum = startNum + (pageSize - 1);
      let total = Math.ceil(dataArr.length / pageSize);
      let inputValNumber = 0;
      let strNumber = 0;
      if (total <= this.page) {
        return false;
      }
      dataArr.forEach((item, keys) => {
        if (keys < endNum) {
          item.forEach((items) => {
            if (items.inputVal != undefined) {
              inputValNumber++;
            }
          });
          strNumber += item.length;
        }
      });
      if (strNumber <= inputValNumber) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.input-panel {
  width: 898px;
  height: 73px;
  background: #fbfbfb;
  box-shadow: inset 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #dbdbdb;
  padding: 10px 10px;
  box-sizing: border-box;
  margin-bottom: 8px;
  span {
    padding: 0px;
    display: inline-block;
  }
  .show-input-panel {
    letter-spacing: 2px;
    width: 100%;
    color: #000000;
    font-weight: 400;
    font-family: Meiryo-Regular, Meiryo;
    font-size: 18px;
    word-spacing: 12px;
    padding: 0 0;
    user-select: none;
  }
  .input-panel-input {
    width: 100%;
    margin-top: 5px;
    input {
      color: #9d9d9d;
      width: 100%;
      font-weight: 400;
      font-size: 18px;
      background: none;
      outline: none;
      border: none;
      padding: 0;
      letter-spacing: 2px;
      font-family: Meiryo-Regular, Meiryo;
    }
  }
  .mistake {
    color: red;
  }
}
</style>
